<template lang="html">
  <div class="">
    <div class="close_over" v-show="show" @click="showClose">
      <img src="../../../assets/image/course/close_over.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: ['closeOverShow'],
  data() {
    return {
      show: this.closeOverShow,
    }
  },
  mounted() {
    
  },
  methods: {
    showClose() {
      this.$emit("parEvn", false);
    }
  },
}
</script>

<style lang="css" scoped>
  .close_over {
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    padding: 0 1.5rem;
    z-index: 10;
  }
  
  .close_over img {
    width: 100%;
  }
</style>
